<template>
  <div>
    <baidu-map
      class="map"
      :center="center"
      :zoom="zoom"
      :scroll-wheel-zoom="false"
      @ready="handler"
    >
      <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
      <bm-overview-map
        anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
        :isOpen="true"
      ></bm-overview-map>
      <bm-marker
        :position="{ lng: center.lng, lat: center.lat }"
        :icon="{
          url: markerImg,
          size: { width: 150, height: 150 }
        }"
      ></bm-marker>
    </baidu-map>
  </div>
</template>

<script>
export default {
  data() {
    return {
      center: { lng: 0, lat: 0 },
      zoom: 3,
      markerImg: require("@/assets/image/about/map-icon.png")
    };
  },
  computed: {},
  mounted() {},
  methods: {
    handler({ BMap, map }) {
      console.log(BMap, map);
      this.center.lng = 113.96;
      this.center.lat = 22.54;
      this.zoom = 15;
    }
  }
};
</script>

<style scoped lang="scss">
.map {
  width: 100%;
  height: 7.8rem;
}
</style>
<style>
.anchorBL {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/about/components/baiduMap.vue